import { useDynamicFormOptions } from 'hooks/selectors'

export { RuleBuilderActionField } from './RuleBuilderActionField'

export const useShippingRuleFormOptions = () => {
    const props = useDynamicFormOptions({ entityKey: 'shipping_rule.entity' })

    return props
}
